import { useEffect } from 'react'

// Captures affiliate referral codes from inbound links and stores them for
// 90 days (localStorage + cookie). Read at signup to set referred_by.
// Accepts ?via= (PromoteKit legacy links), ?ref= and ?r=. Last click wins.
export default function RefCapture() {
  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search)
      // Hash routing: a code pasted after the route (#/pricing?via=x) lands
      // in the hash, not in location.search, so check both
      const hashParams = new URLSearchParams(window.location.hash.split('?')[1] || '')
      const raw =
        params.get('via') || params.get('ref') || params.get('r') ||
        hashParams.get('via') || hashParams.get('ref') || hashParams.get('r')
      if (!raw) return

      if (!/^[a-z0-9_-]{3,20}$/i.test(raw)) return
      const code = raw.toLowerCase()

      const expires = Date.now() + 90 * 864e5
      try {
        localStorage.setItem('bc_ref', JSON.stringify({ code, expires }))
      } catch (e) {
        // localStorage unavailable (private mode etc), cookie below still covers us
      }
      document.cookie = `bc_ref=${code}; path=/; max-age=7776000; SameSite=Lax`

      // Strip the ref param from the address bar now it is banked. Keeps the
      // code out of URLs the user might copy or share, and stops a reload of an
      // old tab re-storing a code that was already consumed at signup. Only the
      // visible URL changes; the stored value is untouched.
      try {
        params.delete('via')
        params.delete('ref')
        params.delete('r')

        // The code can arrive in the hash too (#/pricing?via=x), so clean both
        // sides or a hash-delivered code survives in the address bar.
        const [route, hashQuery] = window.location.hash.split('?')
        let cleanHash = window.location.hash
        if (hashQuery) {
          hashParams.delete('via')
          hashParams.delete('ref')
          hashParams.delete('r')
          const rest = hashParams.toString()
          cleanHash = rest ? `${route}?${rest}` : route
        }

        const query = params.toString()
        const cleanUrl =
          window.location.pathname + (query ? `?${query}` : '') + cleanHash
        window.history.replaceState({}, '', cleanUrl)
      } catch (e) {
        // cosmetic only, never worth breaking the page over
      }
    } catch (e) {
      // ref capture must never break the page
    }
  }, [])

  return null
}
